<template>
  <q-dialog :visible="isVisible" :title="title" width="75%" :innerScroll="false" :showFooter="false" @close="onCancel">
    <el-form ref="addForm" :model="addForm" :rules="rules" label-width="80px">
      <el-table v-loading="loading" :data="tableData.list" height="300px" border style="width: 100%">
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="商品编码" prop="goodsCode" min-width="110"></el-table-column>
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="商品名称" prop="goodsName" min-width="150"></el-table-column>
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="商品定位" prop="goodsLocation"></el-table-column>
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="品类" prop="category"></el-table-column>
        <el-table-column :resizable="true" :show-overflow-tooltip="true" label="风格" prop="style"></el-table-column>
        <el-table-column resizable :show-overflow-tooltip="true" prop="type" width="100" label="所属类型"></el-table-column>
        <el-table-column resizable :show-overflow-tooltip="true" prop="aClass" width="100" label="所属店铺"></el-table-column>
        <el-table-column prop="startDate" label="开始时间" width="100"></el-table-column>
        <el-table-column prop="deliveryCycle" label="发货周期" width="80"></el-table-column>
        <el-table-column prop="skuPromotionName" label="SKU推广名称" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updatedBy" label="更新人" width="80"></el-table-column>
        <el-table-column prop="updatedDate" label="更新时间" width="160"></el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 10px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
        ></el-pagination>
      </div>
    </el-form>
  </q-dialog>
</template>

<script>
import moment from "moment";
import axios from "@/utils/axiosInstance";
export default {
  name: "CRUDEdit",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "调整记录";
    },
  },
  data() {
    return {
      loading: false,
      addForm: {},
      rules: {},
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      currencyForm: {
        pageSize: 30,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "Y",
        groupAttr: "",
      },
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    async init() {
      this.loading = true;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.pageNum = this.tableData.pageNum;
      currencyForm.pageSize = this.tableData.pageSize;
      currencyForm.queryMatch = [
        {
          attributeName: "goodsCode",
          val: this.rowData.goodsCode,
          op: "=",
        },
      ];
      currencyForm.reportCode = "goodsBaseHisInfo";
      axios
        .post(`/ec-pc-api/custom/reports/data/goodsBaseHisInfo`, currencyForm)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>

>>> .el-form-item {
  margin-bottom: 0px
}

>>> .el-form .el-select {
  width: 100px
}

>>> .el-pagination__editor.el-input {
    width: 50px;
}
</style>
